import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConfirmService {
  /**
   * Simple confirmation helper. Uses native `window.confirm` and returns an Observable<boolean>.
   */
  confirm(message: string, title?: string): Observable<boolean> {
    const text = title ? `${title}\n\n${message}` : message;
    const result = window.confirm(text);
    return of(result);
  }
}
